export const appendToFormData = <ObjectType extends Record<string, any>>(object: ObjectType, formData: FormData) => {
  Object.entries(object)
    .filter(([_, value]) => value !== null && value !== undefined && value !== '')
    .forEach(([key, value]) => formData.append(key, value));
};
